import type { GridColumnHeaderParams } from "@mui/x-data-grid-premium";
import { GridHeaderCheckbox, useGridApiContext } from "@mui/x-data-grid-premium";
import { useCallback } from "react";
import { checkSelection } from "@entrilia/shared/utilities/dataGridApiHelper";

interface Props {
  params: GridColumnHeaderParams;
}

interface ExtendedGridColumnHeaderParams extends GridColumnHeaderParams {
  indeterminate?: boolean;
  checked?: boolean;
  disabled?: boolean;
  display?: string;
  onClick?: (e: MouseEvent) => void;
}

const CheckboxGridColumnHeader = ({ params }: Props) => {
  const gridApi = useGridApiContext();

  const handleClick = useCallback(
    (e: MouseEvent) => {
      const { children, indeterminate, checked } = checkSelection(gridApi);
      gridApi.current?.selectRows(children, indeterminate || !checked);
      e.preventDefault();
    },
    [gridApi]
  );

  const { indeterminate } = checkSelection(gridApi);

  const data: ExtendedGridColumnHeaderParams = {
    ...params,
    onClick: handleClick,
    indeterminate,
    display: "hidden",
  };

  return <GridHeaderCheckbox {...data} />;
};

export default CheckboxGridColumnHeader;
